import { Link } from "react-router-dom";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { ArrowUpRight, Banknote, ShieldCheck, TrendingUp } from "lucide-react";

const ICONS = { banknote: Banknote, shield: ShieldCheck, trend: TrendingUp };

export default function ServiceCard({ service: s }) {
  const Icon = ICONS[s.icon];
  const rx = useMotionValue(0);
  const ry = useMotionValue(0);
  const srx = useSpring(rx, { stiffness: 150, damping: 15 });
  const sry = useSpring(ry, { stiffness: 150, damping: 15 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    ry.set(((e.clientX - r.left) / r.width - 0.5) * 12);
    rx.set(-((e.clientY - r.top) / r.height - 0.5) * 12);
  };
  const onLeave = () => {
    rx.set(0);
    ry.set(0);
  };

  return (
    <div style={{ transformPerspective: 1000 }} className="h-full" onMouseMove={onMove} onMouseLeave={onLeave}>
      <motion.div
        style={{ rotateX: srx, rotateY: sry, transformStyle: "preserve-3d" }}
        className="group relative h-full bg-white border border-[#DFE5DC] rounded-3xl overflow-hidden hover:border-[#0C6B4F]/40 hover:shadow-[0_30px_60px_-24px_rgba(15,61,46,0.28)] transition-[border-color,box-shadow] duration-500"
      >
        <div className="absolute inset-0 pointer-events-none overflow-hidden rounded-3xl">
          <div className="absolute top-0 -left-full h-full w-1/2 bg-gradient-to-r from-transparent via-[#0C6B4F]/10 to-transparent -skew-x-12 transition-[left] duration-700 group-hover:left-full" />
        </div>
        <Link to={s.to} data-testid={`service-card-${s.n}`} className="relative flex flex-col h-full p-10" style={{ transform: "translateZ(28px)" }}>
          <div className="flex items-start justify-between">
            <motion.div
              animate={{ y: [0, -6, 0] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
              className="w-14 h-14 rounded-2xl bg-[#0C6B4F] text-white flex items-center justify-center shadow-lg shadow-[#0C6B4F]/30"
            >
              <Icon className="w-6 h-6" strokeWidth={1.75} />
            </motion.div>
            <div className="text-right">
              <p className="font-display text-3xl text-[#C9A227] leading-none">{s.stat}</p>
              <p className="font-mono2 text-[10px] uppercase tracking-[0.15em] text-[#8A978D] mt-1.5">{s.statLabel}</p>
            </div>
          </div>
          <h3 className="font-display text-2xl md:text-3xl mt-8 mb-3 text-[#0F1F1A]">{s.title}</h3>
          <p className="text-[#5C6B62] text-sm leading-relaxed flex-1">{s.desc}</p>
          <span className="mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#5C6B62] group-hover:text-[#0C6B4F] transition-colors duration-300">
            {s.cta}
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </span>
        </Link>
      </motion.div>
    </div>
  );
}
